import { PropsWithChildren } from "react";
import useSwipeDrawer from "common/Gestures/useSwipeDrawer.ts";
import styled from "styled-components";
import { useHandleNavigateBack } from "services/webview/hooks.ts";
import { isIOS } from "react-device-detect";

const SwipeBackButton = ({ children }: PropsWithChildren) => {
  const { navigateBack } = useHandleNavigateBack();
  const { swipeDrawerProps } = useSwipeDrawer({
    isDisabled: !isIOS,
    isLeft: true,
    onSwipe: navigateBack,
  });

  return (
    <SwipeDrawerWrapper {...swipeDrawerProps}>{children}</SwipeDrawerWrapper>
  );
};

export default SwipeBackButton;

const SwipeDrawerWrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;
